<template>
  <v-container>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.push(`/`)"
        >
          <v-icon>mdi-puzzle</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("navigationBar.module") }}</span>
    </v-tooltip>
    <v-card class="mt-12">
      <v-card-title class="primary white--text font-weight-bold">
        <span id="v-step-equipment-list-0">{{
          $t("equipmentList.v-card-title")
        }}</span>
        <export-2-excel
          :dark="true"
          filename="meru-equipment-list"
          sheetname="equipment-list"
          :datos="exportDatos"
        ></export-2-excel>
        <v-spacer></v-spacer>
        <v-text-field
          id="v-step-equipment-list-1"
          dark
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('equipmentList.label-search')"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <keep-alive>
        <v-data-table
          mobile-breakpoint="200"
          :dense="$vuetify.breakpoint.smAndDown"
          sort-by="equipTag"
          :headers="headers"
          :items="equipmentsList"
          :search="search"
          @click:row="rowClick"
          :footer-props="{
            itemsPerPageText: $t('repairList.itemsPerPage'),
            itemsPerPageAllText: $t('repairList.itemsPerPageAllText')
          }"
        >
          <template v-slot:[`item.equipImage`]="{ item }">
            <v-avatar
              id="v-step-equipment-list-2"
              class="my-4 mx-auto"
              width="62"
              height="62"
              tile
              style="border-radius:8px"
            >
              <v-img
                :src="
                  item.pic
                    ? item.pic
                    : 'https://firebasestorage.googleapis.com/v0/b/metax-app.appspot.com/o/equipment%2F1.jpg?alt=media&token=5f313b17-ee39-4090-9087-664e19007bad'
                "
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row> </template
              ></v-img>
            </v-avatar>
          </template>
          <template v-slot:[`item.equipmentType`]="{ item }">
            {{ filterEquipmentType(item.equipmentType) }} </template
          ><template v-slot:[`item.lastInspection`]="{ item }">
            <v-icon
              :color="
                item.lastInspection &&
                item.lastInspection.status &&
                item.lastInspection.status.color
                  ? item.lastInspection.status.color
                  : '#008450'
              "
              >mdi-circle</v-icon
            >
            {{
              item.lastInspection && item.lastInspection.status
                ? translate(item.lastInspection.status.name)
                : $t("equipmentList.zones.smooth")
            }}
          </template>
          <template v-slot:[`item.status`]="{ item }">
            {{
              item.status && item.status.trafficLight
                ? translate(item.status.trafficLight.name)
                : item.status.name
                ? translate(item.status.name)
                : $t("reliability.statuslights.running")
            }}
          </template>

          <template v-slot:[`item.ubicacion`]="{ item }">
            <span class="font-weight-bold"
              >{{ $t("equipmentList.plant") }}:</span
            >
            {{ item.plant.name }}<br />
            <span class="font-weight-bold"
              >{{ $t("equipmentList.area") }}:</span
            >
            {{ item.area.name }}<br />
            <span class="font-weight-bold"
              >{{ $t("equipmentList.unit") }}:</span
            >
            {{ item.unit.name }}<br />
          </template>
          <!--    <template v-slot:item.unit="{ item }">
            <span
              @click="$router.push('/equipment/' + item.id)"
              class="text-center"
            >
              {{ item.unit }}</span
            ></template
          > -->
          <template v-slot:[`item.equipTag`]="{ item }">
            <span class="text-uppercase text-center"> {{ item.equipTag }}</span>
          </template>
        </v-data-table>
      </keep-alive>
      <v-tour
        name="equipmentListTour"
        :callbacks="equipmentListCallBacks"
        :steps="equipmentListSteps"
      ></v-tour>
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";

export default {
  components: {},
  mounted: function() {
    if (!this.user?.equipmentListTour) {
      this.$tours["equipmentListTour"].start();
    }
  },
  data() {
    return {
      equipmentListCallBacks: {
        /*
        onPreviousStep: this.myCustomPreviousStepCallback, */
        onNextStep: this.myCustomNextStepCallback,
        onSkip: this.myCustomSkipCallback
      },
      equipmentListSteps: [
        {
          target: "#v-step-equipment-list-0", // We're using document.querySelector() under the hood
          header: {
            title: this.$t("tour.getStarted")
          },
          content: this.$t("tour.hereYouWillFind")
        },

        {
          target: "#v-step-equipment-list-1", // We're using document.querySelector() under the hood
          header: {
            title: this.$t("tour.smartSearch")
          },
          content: this.$t("tour.ifYouWantToSearch")
        },

        /*  {
          target: ".v-data-table__expand-icon", // We're using document.querySelector() under the hood
          header: {
            title: this.$t("tour.youCanExpandARow")
          },
          content: this.$t("tour.options"),
          before: () => {
            const elements = document.getElementsByClassName(
              "v-data-table__expand-icon"
            );
            elements[0].click(); //IE8 and up, will only select 1 element
            //document.querySelectorAll('.buttonright'); returns a nodelist (array-like object) with all elements that have this class
          }
        }, */
        {
          target: ".v-app-bar__nav-icon", // We're using document.querySelector() under the hood
          header: {
            title: this.$t("tour.navigationDrawerTitle")
          },
          content: this.$t("tour.navigationDrawerContent"),
          params: {
            placement: "right" // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
          before: () => {
            const elements = document.getElementsByClassName(
              "v-app-bar__nav-icon"
            );
            elements[0].click(); //IE8 and up, will only select 1 element
            //document.querySelectorAll('.buttonright'); returns a nodelist (array-like object) with all elements that have this class
          }
        },

        {
          target: "#v-step-equipment-list-2", // We're using document.querySelector() under the hood
          header: {
            title: this.$t("tour.goingToTheDashboard")
          },
          content: this.$t("tour.youCanAlsoUse"),
          before: () => {
            const elements = document.getElementsByClassName(
              "v-app-bar__nav-icon"
            );
            elements[0].click(); //IE8 and up, will only select 1 element
            //document.querySelectorAll('.buttonright'); returns a nodelist (array-like object) with all elements that have this class
          }
        }
      ],
      expanded: [],
      search: this.$route.params.equipTag,
      exportHeaders: [
        {
          text: this.$t("equipmentList.equipTag"),
          value: "equipTag",
          align: "center"
        },
        {
          text: this.$t("equipmentList.operations"),
          value: "lastInspection",
          align: "center"
        },
        {
          text: this.$t("equipmentList.status"),
          value: "status",
          align: "center"
        },
        {
          text: this.$t("equipmentList.equipType"),
          value: "equipmentType",
          align: "center"
        },

        {
          text: this.$t("equipmentList.belongs-to"),
          value: "ubicacion",
          align: "start"
        }
      ],
      headers: [
        {
          text: this.$t("equipmentList.equipImg"),
          value: "equipImage",
          align: "center"
        },
        {
          text: this.$t("equipmentList.equipTag"),
          value: "equipTag",
          align: "center"
        },
        {
          text: this.$t("equipmentList.operations"),
          value: "lastInspection",
          align: "center"
        },
        {
          text: this.$t("equipmentList.status"),
          value: "status",
          align: "center"
        },
        {
          text: this.$t("equipmentList.equipType"),
          value: "equipmentType",
          align: "center"
        },

        {
          text: this.$t("equipmentList.belongs-to"),
          value: "ubicacion",
          align: "start"
        }
      ]
    };
  },
  computed: {
    exportDatos() {
      if (this.equipmentsList) {
        const header = this.exportHeaders.map(h => {
          return h.text;
        });
        const mapedData = this.equipmentsList.map(e => {
          const equipTag = e.equipTag;
          const lastInspection =
            e.lastInspection && e.lastInspection.status
              ? e.lastInspection.status.name
              : "Smooth";
          const status =
            e.status && e.status.trafficLight
              ? e.status.trafficLight.name
              : e.status.name
              ? e.status.name
              : "Running";
          const equipmentType = this.filterEquipmentType(e.equipmentType);
          const location = `${e.plant.name} / ${e.area.name} / ${e.unit.name}`;
          return [equipTag, lastInspection, status, equipmentType, location];
        });
        const datos = [[...header], ...mapedData];
        return datos;
      } else return [["Server", "Error"]];
    },
    ...mapGetters("equipments", ["equipmentsList"]),
    ...mapState("settings", ["equipmentType"]),
    ...mapState("auth", ["user"])
  },

  methods: {
    async myCustomSkipCallback() {
      const payload = {
        db: "users",
        doc: this.user.id,
        data: {
          equipmentListTour: true
        }
      };
      try {
        await this.$store.dispatch("updateDocument", payload);
        this.$dialog.notify.success(
          "You have successfully completed the tour",
          {
            position: "top-right",
            timeout: 5000
          }
        );
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      }
    },
    async myCustomNextStepCallback(currentStep) {
      if (currentStep === 3) {
        const payload = {
          db: "users",
          doc: this.user.id,
          data: {
            equipmentListTour: true
          }
        };
        try {
          await this.$store.dispatch("updateDocument", payload);
          this.$dialog.notify.success(
            "You have successfully completed the tour",
            {
              position: "top-right",
              timeout: 5000
            }
          );
        } catch (error) {
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        }
      }
    },

    goToReliability(item) {
      this.$router.push({
        name: "New/Reliability",
        params: { equipId: item.id }
      });
    },
    rowClick(item, payload) {
      this.$router.push({
        name: "EquipmentProfile/Dashboard",
        params: { id: payload.item.id }
      });
    },
    filterEquipmentType(item) {
      let res = this.equipmentType.filter(e => e.id == item)[0];
      let name = res.name;
      let mainClass = res.mainClass;
      let subtype = res.subtype ? `- ${res.subtype}` : "";
      return `[${mainClass}] ${name} ${subtype}`;
    },
    translate: function(item) {
      var temp = item;

      temp = temp.replace(
        "Running",
        this.$t("reliability.statuslights.running")
      );
      temp = temp.replace(
        "Standby",
        this.$t("reliability.statuslights.standby")
      );
      temp = temp.replace(
        "Maintenance",
        this.$t("reliability.statuslights.maintenance")
      );
      temp = temp.replace(
        "Failure",
        this.$t("reliability.statuslights.failure")
      );

      temp = temp.replace("Smooth", this.$t("reliability.conditions.smooth"));
      temp = temp.replace("Warning", this.$t("reliability.conditions.warning"));
      temp = temp.replace("Alarm", this.$t("reliability.conditions.alarm"));

      return temp;
    }
  },
  filters: {
    FixingDate: function(value) {
      return moment.unix(value.seconds).format("MMMM D YYYY, h:mm:ss a");
    }
  }
};
</script>

<style lang="stylus" scoped></style>
